import s from './Faq.module.css';

export interface FaqItem {
  q: string;
  /** One or more paragraphs. */
  a: string[];
}

/**
 * Native `<details>` — open by keyboard, findable by in-page search, and it
 * works with JavaScript switched off. There is no reason to rebuild this.
 * The marker is a hairline plus/minus drawn in CSS rather than an icon.
 */
export function Faq({ items }: { items: FaqItem[] }) {
  return (
    <div className={s.list}>
      {items.map((item, i) => (
        <details key={item.q} className={s.item}>
          <summary className={s.summary}>
            <span className={s.index} aria-hidden="true">
              {String(i + 1).padStart(2, '0')}
            </span>
            <span className={s.question}>{item.q}</span>
            <span className={s.mark} aria-hidden="true" />
          </summary>
          <div className={s.answer}>
            {item.a.map((paragraph) => (
              <p key={paragraph}>{paragraph}</p>
            ))}
          </div>
        </details>
      ))}
    </div>
  );
}
